var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components/native';
import Text from '../../elements/Text';
import theme from '../../theme';
const StyledTagText = styled((_a) => {
    var { theme } = _a, rest = __rest(_a, ["theme"]);
    return <Text {...rest}/>;
}) `
  flex: 1;
  color: ${({ theme }) => theme.DarkText};
  font-size: ${({ theme }) => theme.labelFontSize};
  line-height: ${({ theme }) => theme.labelFontSize};
  height: ${({ theme }) => theme.labelFontSize};
  margin-right: ${({ theme }) => theme.tenPT};
  padding-top: ${({ theme }) => theme.twoPT};
  ${props => props.textCustomStyle}
`;
StyledTagText.defaultProps = {
    theme: {
        DarkText: theme.DarkText,
        labelFontSize: theme.labelFontSize,
        tenPT: theme.tenPT,
        twoPT: theme.twoPT,
    },
};
export default StyledTagText;
